import { BiExit } from "react-icons/bi";
import { IoLocationSharp } from "react-icons/io5";
import { MdPriceCheck } from "react-icons/md";
import type { TollLocation } from "./api";

// InfoWindow content component for toll locations
const TollInfoWindowContent = ({ toll }: { toll: TollLocation }) => (
    <div className="p-1.5 min-w-[200px] border-l-4 border-blue-500">
        <div className="flex items-center mb-1">
            <IoLocationSharp className="text-blue-600 mr-1 flex-shrink-0" />
            <p className="font-medium text-gray-900 text-sm">{toll.name}</p>
        </div>
        <div className="flex items-center mb-1 text-gray-600 text-xs">
            <BiExit className="mr-1 text-xs flex-shrink-0" />
            <span className="font-medium">{toll.tollSystem}</span>
        </div>
        <div className="flex items-center text-xs">
            <MdPriceCheck className="text-blue-600 mr-1 flex-shrink-0" />
            <span>
                Toll Cost:&nbsp;
                <span className="bg-blue-100 border border-blue-200 px-1 py-0.5 rounded text-blue-800 text-xs font-medium">
                    {toll.price.toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                    })}
                </span>
            </span>
        </div>
    </div>
);

export default TollInfoWindowContent;
